import $ from "jquery";


const getParam = (name, href) => {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var realparams = window.location.search.substr(1);
    if (href && href.indexOf("?") > -1) {
        realparams = href.split("?")[1];
    }
    var r = realparams.match(reg);

    if (r != null) return decodeURIComponent(r[2]);
    return '';
}


if (!$.getParam) {
    $.getParam = getParam;
}

export default $;